// IMPORTANT
// DO NOT REMOVE ANYTHING FROM THIS FILE.
// If a widget ID was used previously and is now being removed, it should be added here.
// The reason is that widget synchronization happens only when the user enters the dashboard (on the frontend).
// A user might have old settings - for example, the Upsell widget is hidden.
// If we re-add that widget to the list as visible by default (our source of truth), it still won’t show up,
// because it remains hidden in the user's settings.
export const deprecatedWidgetIds = ['OverviewMonthly', 'Upsell', 'GetStarted', 'StripePayment'] as const
